export const locationUtils = {
  // Store tokens with expiration
  storeTokens: (selectedLocation) => {
    localStorage.setItem("selectedLocation", JSON.stringify(selectedLocation));
    const tokenExpiry = new Date().getTime() + 60 * 60 * 1000; // 15 minutes
    localStorage.setItem("LocationTokenExpiry", tokenExpiry.toString());
  },

  // Clear all stored tokens and user data
  clearStoredTokens: () => {
    localStorage.removeItem("selectedLocation");
  },

  getSelectedLocation: () => {
    const selLocation = localStorage.getItem("selectedLocation");
    return selLocation ? JSON.parse(selLocation) : null;
  },

  // Check if token is about to expire (within 2 minutes)
  isTokenExpiringSoon: () => {
    const expiry = localStorage.getItem("LocationTokenExpiry");
    if (!expiry) return true;

    const expiryTime = parseInt(expiry);
    const currentTime = new Date().getTime();
    const twoMinutes = 2 * 60 * 1000;
    return expiryTime - currentTime <= twoMinutes;
  }
};
